
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/voie-professionnelle",
      function () {
        return require("private-next-pages/voie-professionnelle.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/voie-professionnelle"])
      });
    }
  